export default __webpack_public_path__ + "static/media/new4.7b8a4bad.jpg";